import { NEW_ADMIN_INVOICES } from 'App/featuresFlags';
import { useGetCountry, useGetTags } from 'domains/Auth/hooks';

function useShowInvoiceCard(): boolean {
  const country = useGetCountry();
  const tags = useGetTags();
  const isBr = country === 'BR';
  const hasInvoiceCard = isBr && tags.includes(NEW_ADMIN_INVOICES);

  return hasInvoiceCard;
}

export default useShowInvoiceCard;
